import { render, staticRenderFns } from "./index.vue?vue&type=template&id=93b8a488&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=93b8a488&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b8a488",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93b8a488')) {
      api.createRecord('93b8a488', component.options)
    } else {
      api.reload('93b8a488', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=93b8a488&scoped=true", function () {
      api.rerender('93b8a488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aftersale/index.vue"
export default component.exports